import { render, staticRenderFns } from "./badut-maskot.vue?vue&type=template&id=cb40b780&"
import script from "./badut-maskot.vue?vue&type=script&lang=ts&"
export * from "./badut-maskot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports